{
  "title": "Incite Greed",
  "source": "Acquisitions Inc.",
  "levelAndSchool": "3rd-level enchantment",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a gem worth at least 50 gp)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "When you cast this spell, you present the gem used as the material component and choose any number of creatures within range that can see you. Each target must succeed on a Wisdom saving throw or be charmed by you until the spell ends, or until you or your companions do anything harmful to it. While charmed in this way, a creature can do nothing but use its movement to approach you in a safe manner. While an affected creature is within 5 feel of you, it cannot move, but simply stares greedily at the gem you present.",
    "At the end of each of its turns, an affected target can make a Wisdom saving throw. If it succeeds, this effect ends for that target."
  ],
  "spellLists": ["cleric", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
